module.exports = __webpack_public_path__ + "static/img/20.c6789be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/20.jpg
// module id = RKtT
// module chunks = 0